import React from 'react';
import { getIniciais } from '../Propostas.design';
import { formatCurrency } from './OrcamentoItens';
import LeadSearch from './LeadSearch';
import { ORCAMENTO_DESIGN as D } from './Orcamento.design';

// Seção "Para quem": lead do CRM (com busca) ou contato digitado à mão. Com um
// lead selecionado, nome vem dele e só e-mail/telefone ficam editáveis.
// `compacto` empilha os campos (colunas estreitas).
export default function OrcamentoCliente({ lead, contato, chatVinculado, onSelectLead, onRemoverLead, onChangeContato, readOnly, compacto }) {
  const gridDupla = compacto ? D.gridStack : D.grid2;
  const gridTripla = compacto ? D.gridStack : D.grid3;

  const avisoChat = chatVinculado && (
    <p className={D.wa}>
      <span className={D.waDot} />
      Conversa do WhatsApp vinculada. O orçamento aparece no chat assim que for criado.
    </p>
  );

  if (lead) {
    return (
      <>
        <div className={D.person}>
          <div className={D.avatar}>{getIniciais(lead.nome)}</div>
          <div className="flex-1 min-w-0">
            <p className={D.personName}>{lead.nome}</p>
            <p className={D.personMeta}>
              Lead do CRM{lead.valor !== undefined && lead.valor !== null ? ` · ${formatCurrency(lead.valor)} em negociação` : ''}
            </p>
          </div>
          {!readOnly && (
            <button type="button" className={D.link} onClick={onRemoverLead}>trocar</button>
          )}
        </div>
        {avisoChat}
        <div className={`${gridDupla} mt-3.5`}>
          <label className={D.field}>
            <span className={D.label}>E-mail</span>
            <input className={D.input} type="email" value={contato.email || ''} onChange={e => onChangeContato({ email: e.target.value })} placeholder="email@empresa.com" disabled={readOnly} />
          </label>
          <label className={D.field}>
            <span className={D.label}>Telefone</span>
            <input className={D.input} value={contato.telefone || ''} onChange={e => onChangeContato({ telefone: e.target.value })} placeholder="(00) 00000-0000" disabled={readOnly} />
          </label>
        </div>
      </>
    );
  }

  return (
    <>
      {!readOnly && (
        <>
          <LeadSearch onSelect={onSelectLead} />
          <p className={D.hint}>Ou preencha abaixo. O contato fica registrado no orçamento.</p>
        </>
      )}

      <div className={`${gridTripla} ${readOnly ? '' : 'mt-3'}`}>
        <label className={D.field}>
          <span className={D.label}>Nome</span>
          <input className={D.input} value={contato.nome || ''} onChange={e => onChangeContato({ nome: e.target.value })} placeholder="Nome do cliente" disabled={readOnly} />
        </label>
        <label className={D.field}>
          <span className={D.label}>E-mail</span>
          <input className={D.input} type="email" value={contato.email || ''} onChange={e => onChangeContato({ email: e.target.value })} placeholder="email@empresa.com" disabled={readOnly} />
        </label>
        <label className={D.field}>
          <span className={D.label}>Telefone</span>
          <input className={D.input} value={contato.telefone || ''} onChange={e => onChangeContato({ telefone: e.target.value })} placeholder="(00) 00000-0000" disabled={readOnly} />
        </label>
      </div>
      {avisoChat}
    </>
  );
}
